export class ManifestoAcaoModel{
    constructor(
        public acao: number = 0,
        public justificativa: string = ''
    )
    {}
}